var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_3",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279,364c0,22.056,17.944,40,40,40h47c22.056,0,40-17.944,40-40v-47c0-22.056-17.944-40-40-40h-47     c-22.056,0-40,17.944-40,40V364z M319,317h47l0.025,46.999c0,0-0.007,0.001-0.025,0.001h-47V317z",
    id: "svg_4",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 210,
    r: 20,
    id: "svg_5",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 210,
    r: 20,
    id: "svg_6",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,352c11.046,0,20-8.954,20-20V120c0-44.112-35.888-80-80-80h-26V20c0-11.046-8.954-20-20-20     c-11.046,0-20,8.954-20,20v20h-91V20c0-11.046-8.954-20-20-20s-20,8.954-20,20v20h-90V20c0-11.046-8.954-20-20-20     s-20,8.954-20,20v20H80C35.888,40,0,75.888,0,120v312c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80     c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40V120     c0-22.056,17.944-40,40-40h25v20c0,11.046,8.954,20,20,20s20-8.954,20-20V80h90v20c0,11.046,8.954,20,20,20     c11.046,0,20-8.954,20-20V80h91v20c0,11.046,8.954,20,20,20c11.046,0,20-8.954,20-20V80h26c22.056,0,40,17.944,40,40v212     C472,343.046,480.954,352,492,352z",
    id: "svg_7",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 384,
    r: 20,
    id: "svg_8",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 210,
    r: 20,
    id: "svg_9",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 297,
    r: 20,
    id: "svg_10",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 297,
    r: 20,
    id: "svg_11",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 210,
    r: 20,
    id: "svg_12",
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 384,
    r: 20,
    id: "svg_13",
    fill: "#ffffff",
    fillOpacity: 1
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_22"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_28"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.68cdae804cd83289701fce0384176800.svg";
export { ForwardRef as ReactComponent };